export default __webpack_public_path__ + "static/media/truck_icon.96bbdafa.svg";